export default {
  customerList: []
};
